"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageViewsApi = exports.getSegmentsValues = void 0;
let caller;
let callerForm;
function getPageViews(params) {
    const { accountId, testId } = params;
    const url = `/api/core/reporting/accounts/${accountId}/tests/${testId}/page_views`;
    return caller(url).get();
}
function getPageViewById(params) {
    const { accountId, pageViewId } = params;
    const url = `/api/core/reporting/accounts/${accountId}/page_view/${pageViewId}`;
    return caller(url).get();
}
function createPageView(params) {
    const { accountId, postParams, testId } = params;
    const { id, ...postParamsWidthoutId } = postParams;
    const url = `/api/core/reporting/accounts/${accountId}/tests/${testId}/page_view`;
    return caller(url).post(postParamsWidthoutId, { withResponse: true });
}
function editPageView(params) {
    const { accountId, pageViewData, testId } = params;
    const { id: pageViewId, ...pageViewDataWidthoutId } = pageViewData;
    const url = `/api/core/reporting/accounts/${accountId}/tests/${testId}/page_view/${pageViewId}`;
    return caller(url).patch(pageViewDataWidthoutId);
}
function deletePageView(params) {
    const { accountId, pageViewId } = params;
    const url = `/api/core/reporting/accounts/${accountId}/page_view/${pageViewId}`;
    return caller(url).delete();
}
function getCustomActionTrackings({ testId, accountId }) {
    const url = `/api/core/reporting/accounts/${accountId}/tests/${testId}/action_trackings?filter[custom]=1&_max_per_page=0`;
    return caller(url).get();
}
function createCustomActionTracking({ testId, accountId, postParams }) {
    const url = `/api/core/reporting/accounts/${accountId}/tests/${testId}/action_tracking`;
    return caller(url).post(postParams, { withResponse: true });
}
function editCustomActionTracking({ testId, accountId, metricId, patchParams }) {
    const url = `/api/core/reporting/accounts/${accountId}/tests/${testId}/action_tracking/${metricId}`;
    return caller(url).patch(patchParams, { withResponse: true });
}
function deleteCustomActionTracking({ accountId, metricId }) {
    const url = `/api/core/reporting/accounts/${accountId}/action_tracking/${metricId}`;
    return caller(url).delete();
}
const getSegmentsValues = ({ accountId, segmentKey, dates }) => callerForm(`queryform/?account=${accountId}&dimensions[]=segmentValue&maxValue=1000&${dates}&filtersValue=segmentKey==${segmentKey}`).get();
exports.getSegmentsValues = getSegmentsValues;
function pageViewsApi(c, callerQueryform) {
    caller = c;
    callerForm = callerQueryform;
    return {
        getSegmentsValues: exports.getSegmentsValues,
        getPageViews,
        getPageViewById,
        createPageView,
        deletePageView,
        getCustomActionTrackings,
        createCustomActionTracking,
        deleteCustomActionTracking,
        editCustomActionTracking,
        editPageView,
    };
}
exports.pageViewsApi = pageViewsApi;
//# sourceMappingURL=api.js.map